var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 23,
    viewBox: "0 0 37 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#707070;}.a{stroke-linejoin:round;}.b{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-102.273 -499)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 18,
    cy: 11,
    rx: 18,
    ry: 11,
    transform: "translate(102.773 499.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(114.773 504.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEye);
export default __webpack_public_path__ + "static/media/passEye.4ead3b52bae246718915b6efd6579a7a.svg";
export { ForwardRef as ReactComponent };